import React, { useState, useEffect, useContext } from 'react';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import ProjectsListCard from '/src/Components/ProjectsListCard/ProjectsListCard';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import CompanySelectionGrid from '/src/Components/CompanySelectionGrid/CompanySelectionGrid';
import { CirclePlus, Pencil } from 'lucide-react';
import { AddressSearchContext, WindowSizeContext } from '/src/App';
import EditPlanModal from './EditPlanModal/EditPlanModal';
import './style.css';

const MyPlans = ({ userPlans, projects, propertyData, handleCreateFirstPlan, handlePlanDelete, handlePlanClick, handlePlanUpdate }) => {

    const { deviceType } = useContext(WindowSizeContext);

    // Get the portalData from the AddressSearchContext
    const { portalData } = useContext(AddressSearchContext);

    // Load the companies and icons from portalData
    const { companies, icons } = portalData;

    // const companies = JSON.parse(localStorage.getItem('companies'));
    // const icons = JSON.parse(localStorage.getItem('icons'));

    // Load the user from local storage
    const user = JSON.parse(localStorage.getItem('user'));

    // Map through the companies and use the 'icon' key as a key to get the icon url and add to company object
    const companiesWithIcons = companies.map(company => ({
        ...company,
        iconUrl: icons[company.icon]
    }));

    // Filter the companies by company_type = 'Retailer'
    const retailers = companiesWithIcons.filter(company => company.company_type === 'Retailer');

    // Filter the companies by company_type = "Service"
    const serviceProviders = companiesWithIcons.filter(company => company.company_type === "Service");

    // Filter the companies by company_type = "Insurance"
    const insuranceCompanies = companiesWithIcons.filter(company => company.company_type === "Insurance");


    // Create the "Other" option
    const otherOption = {
        id: "9999",
        name: "Other",
    }

    // Add the "Other" option to the retailers, service providers, and insurance companies
    retailers.push(otherOption);
    serviceProviders.push(otherOption);
    insuranceCompanies.push(otherOption);

    // Get the user insurance company, preferred retailers, and preferred service providers
    const userInsuranceCompanyLocal = user.insuranceProvider || null;
    const userPreferredRetailersLocal = user.preferredRetailers || [];
    const userPreferredServiceProvidersLocal = user.preferredServiceProviders || [];

    // Set the states for insurance, preferred retailers, and preferred service providers
    const [userInsuranceCompany, setUserInsuranceCompany] = useState(userInsuranceCompanyLocal);
    const [userPreferredRetailers, setUserPreferredRetailers] = useState(userPreferredRetailersLocal);
    const [userPreferredServiceProviders, setUserPreferredServiceProviders] = useState(userPreferredServiceProvidersLocal);

    // Editing of user company preferences
    const [showEditModal, setShowEditModal] = useState(false);
    const [editModalType, setEditModalType] = useState(null);
    const [editModalInfo, setEditModalInfo] = useState({});

    // Editing of user plan
    const [showEditPlanModal, setShowEditPlanModal] = useState(false);
    const [editPlanModalInfo, setEditPlanModalInfo] = useState(null);

    const handleEditPlanButtonClick = (planId) => {

        // Get the plan from the userPlans array
        const plan = userPlans.find((plan) => plan.planId === planId);

        setShowEditPlanModal(true);
        setEditPlanModalInfo(plan);
    }

    const handleEditPlanModuleClose = () => {
        setShowEditPlanModal(false);
        setEditPlanModalInfo(null);
    }

    const handleEditPlanComplete = (updatedPlan) => {

        setShowEditPlanModal(false);
        setEditPlanModalInfo(null);
        handlePlanUpdate(updatedPlan);
    }

    const handleEditPlanDelete = (planId) => {
        setShowEditPlanModal(false);
        setEditPlanModalInfo(null);
        handlePlanDelete(planId);
    }

    // Get the insurance company info from the companies array
    const userInsuranceCompanyInfo = companies.find((company) => company.id === userInsuranceCompany) || null;

    console.log('userInsuranceCompanyInfo', userInsuranceCompanyInfo);

    // Get the insurance company icon
    const userInsuranceCompanyIcon = userInsuranceCompanyInfo ? icons[userInsuranceCompanyInfo.icon] : null;

    //  Get the retailers info from the companies array
    const userPreferredRetailersInfo = companies.filter((company) => userPreferredRetailers.includes(company.id));

    // Get the preferred retailers icons
    const userPreferredRetailersIcons = userPreferredRetailersInfo.map((retailer) => icons[retailer.icon]);

    // Get the preferred service providers info from the companies array
    const userPreferredServiceProvidersInfo = companies.filter((company) => userPreferredServiceProviders.includes(company.id));

    // Get the preferred service providers icons
    const userPreferredServiceProvidersIcons = userPreferredServiceProvidersInfo.map((serviceProvider) => icons[serviceProvider.icon]);

    const [showProjects, setShowProjects] = useState(false);

    const noPlansSentence = "Looks like you don't have any plans yet. Create a plan to get started!";

    const handleEditButtonClick = (type) => {
        setEditModalType(type);
        setShowEditModal(true);
    }

    const handleInsuranceSelection = (companyId) => {
        setUserInsuranceCompany(companyId);
        setShowEditModal(false);
    }

    const handleRetailerSelection = (companyId) => {
        // Add the companyId to the userPreferredRetailers array if it is not already in the array and if so then remove it
        if (userPreferredRetailers.includes(companyId)) {
            setUserPreferredRetailers(userPreferredRetailers.filter((id) => id !== companyId));
        } else {
            setUserPreferredRetailers([...userPreferredRetailers, companyId]);
        }
        // setShowEditModal(false);
    }

    const handleServiceProviderSelection = (companyId) => {
        // Add the companyId to the userPreferredServiceProviders array if it is not already in the array and if so then remove it
        if (userPreferredServiceProviders.includes(companyId)) {
            setUserPreferredServiceProviders(userPreferredServiceProviders.filter((id) => id !== companyId));
        } else {
            setUserPreferredServiceProviders([...userPreferredServiceProviders, companyId]);
        }
    }

    const handleOverlayClick = (e) => {
        // Only close if clicking the overlay itself, not its children
        if (e.target === e.currentTarget) {
            setShowEditModal(false);
        }
    };

    const handleModalClose = () => {
        setShowEditModal(false);
    }

    let editModalHeader = null;
    let editModalUserSelected = null;
    let editModalCompanies = null;
    let editModalHandler = null;

    switch (editModalType) {
        case 'insurance':

            editModalHeader = 'Insurance Provider';
            editModalCompanies = insuranceCompanies;
            editModalUserSelected = userInsuranceCompany;
            editModalHandler = handleInsuranceSelection;

            break;
        case 'retailers':
            editModalHeader = 'Preferred Retailers';
            editModalCompanies = retailers;
            editModalUserSelected = userPreferredRetailers;
            editModalHandler = handleRetailerSelection;


            break;
        case 'serviceProviders':
            editModalHeader = 'Preferred Service Providers';
            editModalCompanies = serviceProviders;
            editModalUserSelected = userPreferredServiceProviders;
            editModalHandler = handleServiceProviderSelection;

            break;
        default:
            editModalHeader = 'Insurance Provider';
            editModalCompanies = insuranceCompanies;
            editModalUserSelected = userInsuranceCompany;
            editModalHandler = handleInsuranceSelection;
    }

    useEffect(() => {
        setEditModalInfo({
            header: editModalHeader,
            companies: editModalCompanies,
            userSelected: editModalUserSelected,
            handler: editModalHandler
        });
    }, [editModalType, userInsuranceCompany, userPreferredRetailers, userPreferredServiceProviders]);

    return (
        <div className="taking-action-section-container">
            {(showEditPlanModal && editPlanModalInfo) && (
                <EditPlanModal
                    plan={editPlanModalInfo}
                    projects={projects}
                    handleEditPlanComplete={handleEditPlanComplete}
                    handleOutsideClick={handleEditPlanModuleClose}
                    handlePlanDelete={handleEditPlanDelete}
                />
            )}
            {showEditModal && (
                <div className="my-plans-edit-modal-overlay" onClick={handleOverlayClick}>
                    <div className="my-plans-edit-modal-container">
                        <h1>Select Your {editModalInfo.header}</h1>
                        <CompanySelectionGrid
                            companies={editModalInfo.companies}
                            userCurrentSelection={editModalInfo.userSelected}
                            handleSelection={editModalInfo.handler}
                        />
                        {editModalType !== 'insurance' &&
                            <button className="my-plans-edit-modal-close-button" onClick={handleModalClose}>Close</button>
                        }
                    </div>
                </div>
            )}
            <div className={`my-plans-header-container ${deviceType}`}>
                <h1>My Plans</h1>
                {userPlans.length > 0 && (
                    <div className="my-plan-add-new-plan-card-frame" onClick={handleCreateFirstPlan}>
                        <div className="my-plan-add-new-plan-icon-container">
                            <CirclePlus />
                        </div>
                        <span>Add New Plan</span>
                    </div>
                )}
            </div>
            {userPlans.length === 0 ? (
                <div className="my-plans-empty-state">
                    <p>{noPlansSentence}</p>
                    <button className="my-plans-empty-state-button" onClick={handleCreateFirstPlan}>Create a Plan</button>
                </div>
            ) : (
                <div className={`my-plans-content-frame ${deviceType}`}>

                    <div className={`my-plans-container ${deviceType}`}>

                        {/* <div className="my-plan-add-new-plan-card-frame" onClick={handleCreateFirstPlan}>
                            <div className="my-plan-add-new-plan-icon-container">
                                <CirclePlus />
                            </div>
                            <span>Create a Plan</span>
                        </div> */}
                        {userPlans.map((plan) => {
                            const planId = plan.planId;

                            // If the plan name is empty, use the timestamp
                            const planName = plan.planName ? plan.planName : plan.timestamp;

                            // Get the project_ids from the plan using the projectData key
                            const projectIds = plan.projectData.map((project) => project.project_id);

                            // Get the projects from the projectIds
                            const planProjects = projectIds.map((projectId) => projects.find((project) => project.project_id === projectId));

                            // Get the count of the projects in plan.projectData where diyPreference is diy and where it is pro
                            const diyProjects = plan.projectData.filter((project) => project.diyPreference === 'diy');
                            const proProjects = plan.projectData.filter((project) => project.diyPreference === 'pro');

                            const sortedProjectsByDiyPreference = [...diyProjects, ...proProjects];

                            const diyProjectsCount = diyProjects.length;
                            const proProjectsCount = proProjects.length;


                            return (
                                <div className={`my-plan-card-frame ${deviceType}`} key={`my-plan-card-${planId}-${planName}`}>

                                    <div className={`my-plan-card ${deviceType}`} key={planId} onClick={() => handlePlanClick(planId)}>
                                        <h2 className='text-align-center'>{planName}</h2>
                                        <div className="my-plan-card-projects-content">
                                            <div className="my-plan-card-projects-project-count-container">
                                                <span className="my-plan-card-projects-count">{planProjects.length}</span>
                                                <span className="my-plan-card-projects-label">Home Improvement Projects</span>
                                            </div>
                                            <CurlyBraceDivider />
                                            {showProjects &&
                                                <div className="my-plan-card-projects-project-diy-vs-pro-count-container">
                                                    <div className="my-plan-card-projects-project-diy-vs-pro-count-individual-container">
                                                        <span className="my-plan-card-projects-count">{diyProjectsCount}</span>
                                                        <span className="my-plan-card-projects-label">Doing it Myself</span>
                                                    </div>
                                                    <div className="my-plan-card-projects-project-diy-vs-pro-count-individual-container">
                                                        <span className="my-plan-card-projects-count">{proProjectsCount}</span>
                                                        <span className="my-plan-card-projects-label">Hiring a Pro</span>
                                                    </div>
                                                </div>
                                            }
                                            {(!showProjects && sortedProjectsByDiyPreference.length > 0 && projects.length > 0) &&
                                                <div className="my-plan-card-projects-project-list-container">
                                                    {sortedProjectsByDiyPreference.map((plan) => {
                                                        console.log('Plan MY PLANS LINE 300', plan, planProjects, projects);
                                                        // Get the project data from the projectData array
                                                        const planProjectId = plan.project_id;
                                                        const projectData = projects.find((project) => project.project_id === planProjectId);

                                                        const diyPreferenceText = plan.diyPreference === 'diy' ? 'DIY' : 'Pro';
                                                        return (
                                                            <div className="my-plan-card-projects-project-list-row-container">
                                                                <div className="my-plan-card-projects-project-list-row-diy-preference-container">
                                                                    <span>{diyPreferenceText}</span>
                                                                </div>
                                                                <ProjectsListCard
                                                                    key={projectData.project_id}
                                                                    project={projectData}
                                                                    handleProjectClick={() => { }}
                                                                    handleAddingProjectToSimulator={() => { }}
                                                                    handleRemovingProjectFromSimulator={() => { }}
                                                                    isSelected={false}
                                                                    simulatorView={false}
                                                                    showAllDetails={false}
                                                                />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            }
                                            {/* <button
                                                className="my-plan-card-view-projects-button"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setShowProjects(!showProjects);
                                                }}
                                            >
                                                {showProjects ? "Hide Projects" : "See Projects"}
                                            </button> */}
                                        </div>
                                        {/* <div className="my-plan-card-progress-bar-container">
                                            <span className="my-plan-card-section-label">My Progress</span>
                                            <div className="my-plan-card-progress-bar">
                                                <div
                                                    className="my-plan-card-progress-bar-fill"
                                                    style={{ width: `${plan.progress * 100 + 33}%` }}
                                                ></div>

                                            </div>
                                            <div className="my-plan-card-progress-bar-scale-container">
                                                <span>0%</span>
                                                <span>50%</span>
                                                <span>100%</span>
                                            </div>
                                        </div> */}
                                    </div>
                                    {/* <button className="my-plan-card-delete-button" onClick={() => handlePlanDelete(plan.planId)}>Delete</button> */}
                                    <button
                                        className="my-plan-card-edit-button"
                                        onClick={() => handleEditPlanButtonClick(plan.planId)}
                                    >
                                        <div className="my-plan-card-edit-button-icon-container">
                                            <Pencil />
                                        </div>
                                        Edit
                                    </button>
                                </div>
                            )
                        })}

                    </div>
                    <div className="my-plans-user-companies-container">
                        <div className="my-plans-user-companies-section-frame">
                                <span>Current Insurance Provider</span>
                                {userInsuranceCompanyIcon &&
                                    <div className="my-plans-user-companies-insurance-company-container">
                                        <img src={CreateCloudfrontUrl(userInsuranceCompanyIcon)} alt="Insurance Company Icon" />
                                    </div>
                                }
                            <button className="my-plans-user-companies-edit-button" onClick={() => handleEditButtonClick('insurance')}>Change</button>
                        </div>

                        <div className="my-plans-user-companies-section-frame">
                            <span>Preferred Retailers</span>
                            <div className="my-plans-user-companies-retailers-service-providers-container">
                                {(userPreferredRetailersIcons && userPreferredRetailersIcons.length > 0) && userPreferredRetailersIcons.map((icon) => (
                                    <div className="my-plans-user-companies-retailer-service-provider-icon-container">
                                        <img src={CreateCloudfrontUrl(icon)} alt="Retailer Icon" />
                                    </div>
                                ))}
                            </div>
                            <button className="my-plans-user-companies-edit-button" onClick={() => handleEditButtonClick('retailers')}>Change</button>
                        </div>
                        <div className="my-plans-user-companies-section-frame">
                            <span>Preferred Service Providers</span>
                            <div className="my-plans-user-companies-retailers-service-providers-container">
                                {(userPreferredServiceProvidersIcons && userPreferredServiceProvidersIcons.length > 0) && userPreferredServiceProvidersIcons.map((icon) => (
                                    <div className="my-plans-user-companies-retailer-service-provider-icon-container">
                                        <img src={CreateCloudfrontUrl(icon)} alt="Service Provider Icon" />
                                    </div>
                                ))}
                            </div>
                            <button className="my-plans-user-companies-edit-button" onClick={() => handleEditButtonClick('serviceProviders')}>Change</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MyPlans;